export default __webpack_public_path__ + "static/media/long-term.7f10524b.png";